import { Button, Col, Form, InputGroup, Modal, Row, Spinner } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux";
import { fetchOtp, resetError, resetStatus, updatePhone, verifyPhone, } from "../store/userProfileSlice";
import { useEffect, useState } from "react";
import LogoutModal from "../../shared/components/LogoutModal";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { logout } from "../../auth/store/authSlice";
import LoadingSpinner from "../../shared/components/LoadingSpinner";



const UserPhoneModal = ({ show, setShow }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const profileDetails = useSelector((state) => state?.userProfile);

    const { status, error, otpMessage, otpStatus, verifyMessage, data, errorStatus, loading } =
        useSelector((state) => state?.userProfile);

    const [otpShow, setOtpShow] = useState(false);
    const [otp, setOtp] = useState({
        value: ''
    });
    const [logoutShow, setLogoutShow] = useState(false);

    useEffect(() => {
        dispatch(updatePhone(data?.phone));
    }, []);

    const queryParams = new URLSearchParams(window.location.search);

    useEffect(() => {
        if (status) {
            window.parent.postMessage(
                { action: "logout" },
                "*"
            );
            dispatch(logout())
            navigate(`/login?${queryParams.toString()}`);
        }

    }, [status])

    useEffect(() => {
        if (errorStatus) {
            toast.error("Error while changing the phone. Please try again later.")
            setOtpShow(false);
            dispatch(resetError());
        }
    }, [errorStatus, dispatch]);

    useEffect(() => {
        if (otpStatus) {
            toast.success(otpMessage)
            setOtpShow(true);
            dispatch(resetStatus())
        }
    }, [otpStatus, otpMessage]);

    const handleLogout = () => {
        let temp = profileDetails;

        const payload = {
            old_phone: temp?.phone,
            new_phone: temp?.newPhone,
            user_otp: otp,
        }
        dispatch(verifyPhone(payload))
        setLogoutShow(false)
    }

    const handleVerify = () => {
        if (!otp || otp.length < 6) {
            toast.error("Please enter OTP")

        } else {
            setLogoutShow(true)
        }
    };

    const handleSubmit = () => {
        let temp = profileDetails;

        if (!temp?.newPhone || temp?.newPhone.trim() === "") {
            toast.error("Please enter the phone number");
            return;
        }

        if (!/^\d{10}$/.test(temp?.newPhone)) {
            toast.error("Please enter a valid 10-digit phone number");
            return;
        }

        if (temp?.newPhone == temp?.phone) {
            toast.error("New phone number cannot be the same as the current phone number");
            return;
        }

        const payload = {
            old_phone: temp?.phone,
            new_phone: temp?.newPhone,
        };
        setOtpShow(true);
        dispatch(fetchOtp(payload));
    };


    return (
        <>

            <ToastContainer />
            <Modal show={show} centered size="md" onHide={() => setShow(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Phone</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col lg={12}>
                            {/* <Form.Label>
                        New Phone
                    </Form.Label> */}
                            <InputGroup>
                                <InputGroup.Text id="phone-prefix">+91</InputGroup.Text>
                                <Form.Control
                                    placeholder="Enter Your Phone"
                                    value={profileDetails?.newPhone}
                                    pattern="[0-9]*"
                                    type="text"
                                    min={0}
                                    maxLength={10}
                                    onChange={(e) => {
                                        dispatch(updatePhone(e.target.value));
                                    }}
                                    autoFocus={true}
                                />

                            </InputGroup>
                        </Col>
                    </Row>
                    {otpShow && <Row className="d-flex mt-5 justify-content-start align-items-center">
                        <Col lg={12}>
                            <Form.Label>
                                Enter OTP
                            </Form.Label>
                            <Form.Control
                                type="text"
                                name="otp"
                                pattern="[0-9]*"
                                minLength={6}
                                maxLength={6}
                                value={otp?.value}
                                onChange={(e) => setOtp(e.target.value)} autoFocus={true}
                            // onKeyDown={handleKeyDown}
                            // onKeyPress={handleVerifyKeyPress}
                            />
                        </Col>
                    </Row>}
                </Modal.Body>
                <Modal.Footer style={{ borderTop: '1px solid lightgray' }}>
                    {!otpShow && <Row className="py-2">
                        <Col lg={12}>

                            <Button
                                onClick={() => {
                                    handleSubmit();

                                }}
                            >
                                Get OTP
                            </Button>

                        </Col>
                    </Row>}

                    {otpShow && <Row className="py-2">
                        <Col lg={12}>
                            <Button className="mx-2" onClick={handleVerify}>Verify</Button>

                            <Button
                                className="mx-2"
                                variant="outline-secondary"
                                onClick={() => {
                                    setOtpShow(false);
                                    setShow(false)
                                }}
                            >
                                cancel
                            </Button>
                        </Col>
                    </Row>}

                </Modal.Footer>
                {loading && <LoadingSpinner />}
            </Modal>

            {logoutShow && <LogoutModal onConfirm={handleLogout} onCancel={setLogoutShow} />}
        </>
    )
}

export default UserPhoneModal;